<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import numericQuantity from "numeric-quantity";

export default {
  props: ["ingredient", "groupId"],
  components: {
    Multiselect,
    numericQuantity,
  },

  computed: {
    ...mapGetters({
      units: "recipes/units",
      ingredients: "recipes/ingredients",
      ingredientItemNumericQuantityOptions:
        "recipes/ingredientItemNumericQuantityOptions",
    }),
    ingredientsWithCreate() {
      return [
        {
          value: "create",
          text: "New ingredient",
        },
        ...this.ingredients,
      ];
    },
  },

  data() {
    return {
      selectedUnit: "",
      id: this.groupId,
      selectedIngredient: this.ingredient.ingredient
        ? this.ingredient.ingredient
        : "",
      amount: this.ingredient.amount ? this.ingredient.amount : "",
      note: this.ingredient.note ? this.ingredient.note : "",
      unit: this.ingredient.unit ? this.ingredient.unit : "",
      timeout: null,
      ingredientId: this.ingredient ? this.ingredient.id : null,
      ingredientStatus: this.ingredient ? this.ingredient.status : null,
      uuid: this.ingredient ? this.ingredient.id : null,
    };
  },
  watch: {
    selectedIngredient(newVal, oldVal) {
      if (newVal === "create") {
        var ingredientItem = {
          id: this.ingredientId,
          ingredient_group: this.groupId,
          position: this.ingredient.position,
          amount: this.amount,
          note: this.note,
          ingredient: this.selectedIngredient,
          status: this.ingredientStatus,
        };

        this.$store.commit("recipes/setEmptyIngredient");
        this.$store.commit("recipes/setCurrentIngredientMode", {
          status: "create",
          ingredient: ingredientItem,
        });

        this.$store.dispatch("recipes/openIngredientsModal");

        this.timeout = setTimeout(() => {
          this.selectedIngredient = oldVal;
        }, 1);
        return false;
      } else {
        if (newVal != "") {
          this.selectedIngredient = newVal;
          var data = {
            status: this.ingredientStatus,
            ingredient_group: this.groupId,
            position: this.ingredient.position,
            amount: this.amount,
            note: this.note,
            ingredient: newVal,
          };
          this.createUpdate(data);

          if (newVal) {
            this.$store
              .dispatch("recipes/getIngredientRecipe", newVal)
              .then((ing) => {
                this.unit = ing.unit_name;
                // if (ing.unit) {
                //   this.$store
                //     .dispatch("recipes/getUnit", ing.unit)
                //     .then((unit) => {
                //       console.log(unit)
                //     });
                // } else {
                //   this.unit = "";
                // }
              });
          }
        }
      }
    },
  },
  methods: {
    editIngredient() {
      this.$store.dispatch("recipes/getIngredient", this.selectedIngredient);
      var ingredientItem = {
        id: this.ingredientId,
        ingredient_group: this.groupId,
        position: this.ingredient.position,
        amount: this.amount,
        note: this.note,
        ingredient: this.selectedIngredient,
        status: this.ingredientStatus,
      };
      this.$store.commit("recipes/setCurrentIngredientMode", {
        status: "update",
        ingredient: ingredientItem,
      });
      this.$store.dispatch("recipes/openIngredientsModal");
    },
    saveIngredient() {
      var ingredientItem = {
        ingredient_group: this.groupId,
        position: this.ingredient.position,
        amount: this.amount,
        note: this.note,
        ingredient: this.selectedIngredient,
      };
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.createUpdate(ingredientItem);
      }, 1000);
    },
    createUpdate(ingredientItem) {
      if (this.ingredientStatus == "create") {
        this.$store
          .dispatch("recipes/createIngredientGroupItem", ingredientItem)
          .then((res) => {
            this.ingredientId = res.id;
            this.ingredientStatus = "added";
            this.$emit("ingredient-saved", {
              itemId: res.id,
              uuid: this.uuid,
              ingredient_group: res.ingredient_group,
              position: res.position,
              amount: res.amount,
              note: res.note,
              ingredient: res.ingredient,
              unit: res.unit,
            });
            this.$store.commit(`commons/setSavingForm`, "Saved");
          });
      } else {
        ingredientItem.id = this.ingredientId;
        this.$store
          .dispatch("recipes/updateIngredientGroupItem", ingredientItem)
          .then((res) => {
            this.$store.commit(`commons/setSavingForm`, "Saved");
          });
      }
    },
    deleteIngredientGroupItem(id) {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("recipes/deleteIngredientGroupItem", id)
        .then((res) => {
          this.$store.commit(`commons/setSavingForm`, "Deleted");
          this.$store.commit("commons/setPreloader", false);
        });
    },
    selectAmount($e) {
      if (isNaN(parseFloat(numericQuantity($e)))) {
        this.$store.commit(`commons/setSavingErrorMessage`, "Invalid Amount");

        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.amount = "";
        }, 1);
        return false;
      }

      var data = {
        ingredient_group: this.groupId,
        position: this.ingredient.position,
        amount: $e,
        note: this.note,
        ingredient: this.selectedIngredient,
      };

      const status = this.ingredientItemNumericQuantityOptions
        ? this.ingredientItemNumericQuantityOptions.find(
            (option) => option.value == $e
          )
        : null;

      if (!status) {
        this.$store
          .dispatch("recipes/createIngredientItemNumericQuantity", {
            numeric_representation: $e,
            value: numericQuantity($e),
          })
          .then(
            (res) => {
              data.amount = res.value;
              this.createUpdate(data);
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.createUpdate(data);
      }
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
  },
};
</script>

<style lang="scss">
.selected-item {
  position: absolute;
}
.ingredient {
  display: grid;
  grid-template-columns: 0.5fr 4fr 1.5fr 1fr 3fr 0fr;
  gap: 15px;
  margin-bottom: 0.5rem;
  counter-increment: my-awesome-counter;
  position: relative;
  .unit {
    font-size: 14px;
  }
}
.ingredient:before {
  font-size: 14px;
  content: counter(my-awesome-counter);
  position: absolute;
  top: 8px;
  left: 20px;
  margin: auto;
}
.box-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.box-start {
  display: flex;
  align-items: center;
}
.pencil-position {
  position: absolute;
  right: 5px;
}
.pencil-position .icon {
  margin-right: 0.4rem;
}
.single-label {
  font-size: 0.8rem;
}
.multiselect__single {
  padding-right: 3px;
}
.option-item {
  width: 100%;
  position: relative;
}
.option-item .icon {
  position: absolute;
  right: 0;
}

.multiselect-caret,
.multiselect-clear-icon {
  display: none !important;
}

.amount-dropdown {
  .multiselect-caret {
    display: block !important;
  }
}

.multiselect,
.multiselect-options {
  .selected-item,
  .option-item {
    span {
      &.small {
        color: #8e8e8e;
      }
    }
  }

  .is-selected {
    .option-item {
      span {
        &.small {
          color: #fff !important;
        }
      }
    }
  }
}
</style>
<template>
  <div>
    <div class="ingredient">
      <div class="box box-start">
        <b-icon icon="list"></b-icon>
      </div>
      <div class="box">
        <multiselect
          v-model="selectedIngredient"
          :options="ingredientsWithCreate"
          :hide-selected="true"
          :searchable="true"
          track-by="text"
          label="text"
        >
          <template slot="option" slot-scope="{ option }">
            <div class="option-item">
              <span
                >{{ option.text }}
                <span class="small">{{ option.unit_name }}</span></span
              >
              <b-icon
                class="icon"
                icon="plus-circle"
                v-if="option.value === 'create'"
              ></b-icon>
            </div>
          </template>

          <template slot="singlelabel" slot-scope="{ value }">
            <div
              class="
                selected-item
                d-flex
                justify-content-between
                align-items-center
                pr-3
              "
              v-if="value"
            >
              <span
                >{{ value.text }}
                <span class="small">{{ ingredient.unit }}</span></span
              >
              <span @click="editIngredient"
                ><b-icon
                  class="icon"
                  icon="pencil"
                  v-if="value !== 'create'"
                ></b-icon
              ></span>
            </div>
          </template>
        </multiselect>
      </div>
      <div class="box amount-dropdown">
        <multiselect
          v-model="amount"
          :options="ingredientItemNumericQuantityOptions"
          :hide-selected="true"
          :searchable="true"
          label="text"
          track-by="text"
          :create-tag="true"
          @change="selectAmount"
          :disabled="ingredientStatus == 'create'"
        >
          <template v-slot:singlelabel="{ value }">
            <div class="multiselect-single-label" v-if="value">
              {{ value.text }}
            </div>
          </template>
        </multiselect>
      </div>
      <div class="box unit d-flex align-items-center justify-content-center">
        {{ ingredient.unit }}
      </div>
      <div class="box">
        <b-form-input
          size="sm"
          v-model="note"
          @keyup="saveIngredient"
          :disabled="ingredientStatus == 'create'"
        ></b-form-input>
      </div>
      <div class="box box-end">
        <b-icon
          icon="trash"
          class="cursor-pointer"
          variant="danger"
          @click="deleteIngredientGroupItem(ingredientId)"
        ></b-icon>
      </div>
    </div>
  </div>
</template>